import { connect } from 'react-redux';
import RegisterOrg from './RegisterOrg';
import { fetchRegisterOrganization } from '../../../reducers/organization/organizations';
import { resetSubmitFormData } from './../../../reducers/common/submitForm';
import {
    getCurrentContinent,
    setCurrentContinent,
    getCountriesData,
    getContinentsData
} from './../../../reducers/common/location';
import { getTranslation } from "../../../reducers/common/localization";
import { fetchGetPriceByOrgTypeAndCountry } from '../../../reducers/finance/finance';
import { showModal, MODAL_CREATE_ORG_PRICE } from "../../../reducers/common/activeModal";
import { getSubmitFormSuccessStatus } from "../../../reducers/common/submitForm";

const mapStateToProps = (state) => {

    return {
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
        translation: getTranslation(state),
        success: getSubmitFormSuccessStatus(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onShowFinance: (orgType, countryCode) => {
            dispatch(fetchGetPriceByOrgTypeAndCountry(orgType, countryCode));
            dispatch(showModal({ modalKey: MODAL_CREATE_ORG_PRICE }))
        },
        onRegister: (data) => {
            dispatch(fetchRegisterOrganization(data));
        },
        onContinentSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        onResetData: () => {
            dispatch(resetSubmitFormData());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterOrg);



// WEBPACK FOOTER //
// ./src/components/organizationManagement/registerOrg/RegisterOrg.container.js